import React, { useState } from "react";
import { X } from "lucide-react";

const FreeTrial = ({ show, handleClose }) => {
  const [formData, setFormData] = useState({
    fullName: "",
    email: "",
    website: "",
    contact: "",
  });

  if (!show) return null;

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = () => {
    if (!formData.fullName || !formData.email || !formData.contact) {
      alert("Please fill all required fields");
      return;
    }

    console.log("Form submitted:", formData);
    handleClose();

    setFormData({
      fullName: "",
      email: "",
      website: "",
      contact: "",
    });
  };

  return (
    <div
      style={overlayStyle}
      onClick={handleClose} // ✅ background click closes modal
    >
      <div
        style={modalStyle}
        onClick={(e) => e.stopPropagation()} // ✅ modal click safe
      >
        {/* animation */}
        <style>{`
          @keyframes modalFadeIn {
            from { opacity: 0; transform: translateY(-20px); }
            to { opacity: 1; transform: translateY(0); }
          }
        `}</style>

        {/* Close button */}
        <button onClick={handleClose} style={closeBtn}>
          <X size={16} />
        </button>

        <h3 style={titleStyle}>Start Your Free Trial</h3>

        <p style={descStyle}>
          Please fill out the form below and we will ensure a personalised demo
          catering to your requirements.
        </p>

        <Input
          label="Full Name *"
          name="fullName"
          value={formData.fullName}
          onChange={handleInputChange}
        />

        <Input
          label="Work Email *"
          name="email"
          value={formData.email}
          onChange={handleInputChange}
          type="email"
        />

        <Input
          label="Website (Optional)"
          name="website"
          value={formData.website}
          onChange={handleInputChange}
        />

        <Input
          label="Contact Number *"
          name="contact"
          value={formData.contact}
          onChange={handleInputChange}
        />

        <button style={submitBtn} onClick={handleSubmit}>
          Start Free Trial
        </button>
      </div>
    </div>
  );
};

export default FreeTrial;

/* ---------------- styles ---------------- */

const overlayStyle = {
  position: "fixed",
  inset: 0,
  backgroundColor: "rgba(0,0,0,0.5)",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  zIndex: 9999,
  padding: "1rem",
};

const modalStyle = {
  maxWidth: "600px",
  width: "100%",
  background: "#fff",
  borderRadius: "1rem",
  padding: "2rem",
  position: "relative",
  animation: "modalFadeIn 0.3s ease-out",
};

const closeBtn = {
  position: "absolute",
  top: 12,
  right: 12,
  border: "none",
  background: "#f1f1f1",
  borderRadius: "50%",
  width: 36,
  height: 36,
  cursor: "pointer",
};

const titleStyle = {
  textAlign: "center",
  fontWeight: "bold",
  color: "#0c4d45",
  marginBottom: "1rem",
};

const descStyle = {
  textAlign: "center",
  color: "#6c757d",
  marginBottom: "1.5rem",
};

const submitBtn = {
  width: "100%",
  padding: "0.75rem",
  backgroundColor: "#0c4d45",
  color: "#fff",
  border: "none",
  borderRadius: "50rem",
  fontWeight: 500,
  cursor: "pointer",
};

/* reusable input */
const Input = ({ label, ...props }) => (
  <div style={{ marginBottom: "1rem" }}>
    <label style={{ fontWeight: 500, color: "#0c4d45" }}>{label}</label>
    <input
      {...props}
      style={{
        width: "100%",
        padding: "0.75rem",
        border: "1px solid #ced4da",
        borderRadius: "0.375rem",
      }}
    />
  </div>
);
